<template>
  <div class="w-100 position-relative">
    <div v-if="!module_unavailable"
      :class="{
        'p-4 mb-4 pb-2 rounded-6 box-shadow-main bg-white': window_width > 768
      }">
      <div class="w-100" v-if="is_load">
        <loader/>
      </div>
      <div class="w-100" v-else>  
        <ErrorMessage v-if="error != ''" :message="error" />
        <template v-else>
          <span id="addt_srv_wrap" class="position-absolute" style="top: -80px;"></span>
          <div class="d-flex justify-content-between align-items-start cursor-pointer" @click="toggleView">
            <div class="mr-md-4 mr-3">
              <img src="../../../../assets/img/icon/accept.png" :width="window_width > 768 ? 40 : 24">
            </div>
            <div class="w-100">
      				<p class="mb-0" :class="window_width > 768 ? 'heading-6-1' : 'body-2-4'">{{getMerchant.cart_additional_service_title}}</p>
              <p class="mb-0" :class="window_width > 768 ? 'body-2-2' : 'body-3-3'">
                <template v-if="getBeCartAddtService.length == 0">
                  {{getMerchant.cart_additional_service_subtitle}}
                </template>
                <template v-else>
                  {{$t('hotel.you-have')}} {{getBeCart.qty.additional_service}} {{$t('hotel.additional-service-adedd')}}
                </template>
              </p>
            </div>
            <div>
              <svg width="23" height="14" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.4235 14C11.7521 14 12.0807 13.8685 12.3043 13.6187L22.4789 3.19435C22.7023 2.97088 22.8338 2.68167 22.8338 2.35304C22.8338 1.66947 22.321 1.14365 21.6375 1.14365C21.3089 1.14365 21.0066 1.2751 20.783 1.48543L10.7136 11.7784H12.1202L2.05069 1.48543C1.84037 1.2751 1.53802 1.14365 1.19625 1.14365C0.512674 1.14365 0 1.66947 0 2.35304C0 2.68167 0.131456 2.97088 0.354928 3.2075L10.5296 13.6187C10.7793 13.8685 11.0817 14 11.4235 14Z" class="fill-primary" />
              </svg>
            </div>
          </div>
          <b-collapse v-model="expand_view" class="mt-4">
            <template v-if="expand_view">
              <template v-if="view_type == 'full'">
                <div v-if="category.list.length > 0" class="w-100 mb-4">
                  <div class="border-bottom w-100">
                    <p class="px-3 mb-0 d-inline-block align-middle body-2 py-2" v-for="cat in category.list" :class="cat.id == category.selected.id ? 'border-bottom-orange-3 text-orange' : 'cursor-pointer'" @click="setActiveCategory(cat)">{{cat.name}}</p>
                  </div>
                </div>
  
                <div class="row" v-if="is_load_product">
                  <div class="col-6 mb-4" v-for="i in 2">
                    <div class="w-100">
                      <div class="row no-gutters">
                        <div class="col-4"> 
                          <div class="w-100 radius-6 position-relative" style="height: 110px;overflow: hidden;">
                            <b-skeleton-img no-aspect height="110px"></b-skeleton-img>
                          </div>
                        </div>
                        <div class="col-8">
                          <div class="pl-3">
                            <b-skeleton width="50%" height="21.3333px" class="mb-1"></b-skeleton>
                            <b-skeleton width="100%" height="16px" class="mb-1"></b-skeleton>
                            <b-skeleton width="30%" height="18px" class="mb-2"></b-skeleton>
                            <b-skeleton width="30%" height="32px" class="d-table ml-auto"></b-skeleton>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <template v-else>
                  <ErrorMessage v-if="error_product != ''" :message="error_product" />
                  <template v-else>
                    <div class="row slim-grid-row mb-3" :key="load_product_key">
                      <template v-for="(product,index) in product_list">
                        <div
                          v-if="category.selected.total_product_display == -1 || index < category.selected.total_product_display" 
                          class="col-xl-6 col-12 mb-4">
                          <Product :data="product" v-if="category.selected.merchant_pos == null" />
                          
                          <OutletProduct 
                            v-else-if="category.selected.merchant_pos.pos_type == 'RESTAURANT'" 
                            type="block" 
                            :data="product"
                            :index="index"
                            :pos="category.selected.merchant_pos"
                            :products_length="product_list.length"
                            page_module="additional_service" />
    
                          <ActivityProduct
                            :data="product"
                            :general_data="general_data_activity"
                            page_module="additional_service"
                            v-else-if="category.selected.merchant_pos.pos_type == 'SPA' || category.selected.merchant_pos.pos_type == 'ACTIVITY'"
                            />
    
                          <VoucherProduct
                            v-else-if="category.selected.merchant_pos.pos_type == 'VOUCHER'"
                            :data="product"
                            page_module="additional_service"
                            />
                        </div>
                      </template>
                    </div>
                    <div class="w-100 text-center mt-3" v-if="category.selected.total_product_display != -1">
                      <button class="g-btn g-btn-md g-btn-primary-outline px-4" @click="displayMoreProduct(category.selected)">Load More</button>
                    </div>
                  </template>
                </template>
              </template>
              <template v-else>
                <div class="w-100" :key="load_product_key">
                  <div class="w-100 mb-5" v-for="(ctg,ctg_i) in category.list">
                    <div class="w-100 mb-4">
                      <p class="mb-0 sub-heading-1-2">{{ ctg.name }}</p>
                      <p v-if="$isNotEmpty(ctg.description)" class="mb-0 body-2-2">{{ ctg.description }}</p>
                    </div>
                    
                    <div class="row" v-if="ctg.is_load">
                      <div class="col-6 mb-4" v-for="i in 2">
                        <div class="w-100">
                          <div class="row no-gutters">
                            <div class="col-4"> 
                              <div class="w-100 radius-6 position-relative" style="height: 110px;overflow: hidden;">
                                <b-skeleton-img no-aspect height="110px"></b-skeleton-img>
                              </div>
                            </div>
                            <div class="col-8">
                              <div class="pl-3">
                                <b-skeleton width="50%" height="21.3333px" class="mb-1"></b-skeleton>
                                <b-skeleton width="100%" height="16px" class="mb-1"></b-skeleton>
                                <b-skeleton width="30%" height="18px" class="mb-2"></b-skeleton>
                                <b-skeleton width="30%" height="32px" class="d-table ml-auto"></b-skeleton>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <template v-else>
                      <ErrorMessage v-if="ctg.error != ''" :message="ctg.error" />
                      <template v-else>
                        <div class="row slim-grid-row">
                          <div 
                            class="col-xl-6 col-12 mb-4"
                            v-for="(product,index) in ctg.product_list">
                            <Product :data="product" v-if="ctg.merchant_pos == null" />
                            
                            <OutletProduct 
                              v-else-if="ctg.merchant_pos.pos_type == 'RESTAURANT'" 
                              type="block" 
                              :data="product"
                              :index="index"
                              :pos="ctg.merchant_pos"
                              :products_length="ctg.product_list.length"
                              page_module="additional_service" />
      
                            <ActivityProduct
                              :data="product"
                              :general_data="ctg.general_data"
                              page_module="additional_service"
                              v-else-if="ctg.merchant_pos.pos_type == 'SPA' || ctg.merchant_pos.pos_type == 'ACTIVITY'"
                              />
      
                            <VoucherProduct
                              v-else-if="ctg.merchant_pos.pos_type == 'VOUCHER'"
                              :data="product"
                              page_module="additional_service"
                              />
                          </div>
                        </div>
                        <div class="w-100 text-center mt-3" v-if="total_product_preview < ctg.total_additional_service">
                          <button class="g-btn g-btn-md g-btn-primary-outline px-4" @click="changeViewType(ctg_i)">Load More</button>
                        </div>
                      </template>
                    </template>
                  </div>
                </div>
              </template>
            </template>
          </b-collapse>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters,mapMutations} from 'vuex'
  import {get} from '@/services/index.js';
  import Product from './Product'
  import OutletProduct from '../../concierge/pos/Product'
  import ActivityProduct from '../../concierge/activity/Product'
  import VoucherProduct from '@/components/hotel/upselling/VoucherItem'

  export default {
    components:{
      Product,
      OutletProduct,
      ActivityProduct,
      VoucherProduct
    },
    data() {
      return {
        module_unavailable: false,
        is_load: true,
        error: '',
        view_type: 'full',
        category: {
          list: [],
          selected: {}
        },
        product_list: [],
        load_product_key: 0,
        expand_view: true,
        is_load_product: true,
        error_product: '',
        window_width: window.innerWidth,
        general_data_activity: {},
        total_product_preview: 2
      }
    },
    watch:{
      module_unavailable(){
        this.$emit('updateVisibility', !this.module_unavailable);
      }
    },
    computed: {
      ...mapGetters([
        'getMerchant',
        'getBeCartAddtService',
        'getBeCart',
        'getOutletTrxPageModule',
        'getActivityTrxPageModule',
        'getVoucherPageModule'
      ])
    },
    mounted(){
      this.loadFirstData()
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResizeWindow);
      })
    },
    beforeDestroy() { 
      window.removeEventListener('resize', this.onResizeWindow); 
    },
    methods:{
      ...mapMutations(['clearTrxOutletProduct','clearTrxActivityProduct','resetAllDataMarketing']),
      onResizeWindow(){
        this.window_width = window.innerWidth
      },
      resetData(){
        if(this.getOutletTrxPageModule != 'additional_service'){
          this.clearTrxOutletProduct()
        }
        if(this.getActivityTrxPageModule != 'additional_service'){
          this.clearTrxActivityProduct()
        }
        if(this.getVoucherPageModule != 'Cart'){
          this.resetAllDataMarketing()
        }
        
        this.module_unavailable = false
        this.is_load = true
        this.error = ''
        this.category = {
          list: [],
          selected: {}
        },
        this.product_list = []
        this.is_load_product = true,
        this.error_product = ''
      },
      loadFirstData(){
        this.resetData()
        
        // LOAD ALL CATEGORY
        this.loadCategory()
        .then(category_res=>{
          if(category_res.length > 0){
            this.category.list = category_res
            this.category.list = this.category.list.map(x=>{
              x.total_additional_service = 0
              let is_module_activity = this.$isNotEmpty(x.merchant_pos) &&  (x.merchant_pos.pos_type == 'SPA' || x.merchant_pos.pos_type == 'ACTIVITY')
              
              x.total_product_display = this.$isNotEmpty(x.merchant_pos) && (is_module_activity || x.merchant_pos.pos_type == 'VOUCHER') ? 2 : 6
              
              if(x.merchant_pos == null) x.page_module = 'ORIGINAL'
              else if(is_module_activity) x.page_module = 'ACTIVITY'
              else x.page_module = x.merchant_pos.pos_type
              return x
            })

            this.loadProduct(null,true)
            .then(product_res=>{
              if(product_res.data.length > 0){
                this.category.list.push({
                  id: null,
                  name: 'Uncategorized',
                  total_additional_service: product_res.total_product,
                  total_product_display: 6
                })
              }
            })
            this.setActiveCategory(this.category.list[0])
            
            // this.toggleView()
          }else{
            // LOAD UNCATEGORIZED PRODUCT
            this.loadProduct(null)
            .then(product_res=>{
              if(product_res.data.length == 0){
                this.module_unavailable = true
              }
            })
            
          }
          this.is_load = false
        })
        .catch(caegory_err=>{
          this.error = caegory_err
          this.is_load = false
        })
      },
      loadCategory(){
        return new Promise((success,fail)=>{
          get("CORE_HOTEL","hotel-additional-service-category",{
            merchant_id: this.getMerchant.id
          }).then(response=>{
            let res = response.data
            if(res.success){
              success(res.data)
            }else{
              fail(res.message)
            }
          })
        })
      },
      loadProduct(category_id,just_checking=false){
        return new Promise((success,fail)=>{
          if(!just_checking){
            this.is_load_product = true
            this.error_product = ''
          }
          get("CORE_HOTEL","hotel-additional-service",{
            merchant_id: this.getMerchant.id,
            category_id: category_id,
            page_size: null,
            use_cm_transport: 'false'
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.product_list = res.data
              success(res)
            }else{
              if(!just_checking) this.error_product = res.message
              fail(res.message)
            }
            if(!just_checking) this.is_load_product = false
          })
        })
      },
      loadGeneralDataActivity(merchant_pos){
        return new Promise((success, fail) => {
          this.general_data_activity = {}
          let is_spa = merchant_pos.pos_type == 'SPA'
          let api = {
            module: is_spa ? 'CONCIERGE' : 'CORE_HOTEL',
            url: is_spa ? 'spa/general' : `merchant-pos/${merchant_pos.id}/general`
          }
          
          get(api.module, api.url, {
            merchant_id: this.getMerchant.id
          }).then(response => {
            let res = response.data
            if (res.success) {
              this.general_data_activity = res.data
              success(res.data)
            } else {
              fail(res.message)
            }
          })
        })
      },
      loadProductPerCategory(){
        this.category.list = this.category.list.map(x=>{
          x.is_load = true
          x.key = 0
          x.error = ''
          x.general_data = {}
          x.product_list = []
          if(x.merchant_pos == null) x.page_module = 'ORIGINAL'
          else if(x.merchant_pos.pos_type == 'SPA' || x.merchant_pos.pos_type == 'ACTIVITY') x.page_module = 'ACTIVITY'
          else x.page_module = x.merchant_pos.pos_type
          return x
        })
        
        let loadProductUncategorized = () => {
          this.loadProduct(null,this.total_product_preview)
          .then(product_res=>{
            if(product_res.data.length > 0){
              this.category.list.push({
                id: null,
                name: 'Uncategorized',
                general_data: {},
                product_list: product_res.data,
                page_module: 'ORIGINAL',
                is_load: false,
                error: '',
                total_additional_service: product_res.total_product
              })
            }
          })
        }

        loadProductUncategorized()
        // this.changeViewType(0)

        // this.category.list.forEach((category,category_i) => {
        //   this.category.list[category_i].error = ''
          
        //   let fillProduct = (cat_id, cat_index) => {
        //     this.loadProduct(cat_id,this.total_product_preview)
        //     .then(product_res => {
        //       this.category.list[cat_index].product_list = product_res.data
        //     })
        //     .catch(product_err=>{
        //       this.category.list[cat_index].error = product_err
        //     })
        //     .finally(()=>{
        //       this.category.list[cat_index].is_load = false
        //       this.load_product_key++
        //     })
        //   }
          
        //   if(category.page_module == 'ACTIVITY'){
        //     this.loadGeneralDataActivity(category.merchant_pos)
        //     .then(general_data_res=>{
        //       this.category.list[category_i].general_data = general_data_res
        //       fillProduct(category.id, category_i)
        //     })
        //     .catch(general_data_err=>{
        //       this.category.list[category_i].error = general_data_err
        //     })
        //     .finally(()=>{
        //       this.category.list[category_i].is_load = false
        //       this.load_product_key++
        //     })
        //   }else{
        //     fillProduct(category.id, category_i)
        //   }

        //   if(category_i+1 == this.category.list.length){
        //     loadProductUncategorized()
        //   }
        // });

      },
      toggleView(){
        this.expand_view = !this.expand_view
        if(this.expand_view){
          // this.loadProductPerCategory()
          this.setActiveCategory(this.category.list[0])
        }
      },
      setActiveCategory(category){
        this.category.selected = category
        this.product_list = []
        this.load_product_key++
        if(category.page_module == 'ACTIVITY'){
          this.loadGeneralDataActivity(category.merchant_pos)
          .then(()=>{
            this.loadProduct(category.id).then(product_res=>{
              if(product_res.total_product <= this.category.selected.total_product_display) this.category.selected.total_product_display = -1
              this.load_product_key++
            })
          })
        }else{
          this.general_data_activity = {}
          this.loadProduct(category.id).then(product_res=>{
            if(product_res.total_product <= this.category.selected.total_product_display) this.category.selected.total_product_display = -1
            this.load_product_key++
          })
        }
      },
      changeViewType(category_i){
        this.category.list = this.category.list.map(x=>{
          x.general_data = {}
          x.product_list = []
          return x
        })
        
        this.view_type = 'full'
        // setTimeout(() => {
        //   this.$smoothScroll('addt_srv_wrap')
        // }, 100);
        this.setActiveCategory(this.category.list[category_i])
      },
      displayMoreProduct(category){
        let category_index = this.category.list.findIndex(x=>x.id == category.id)
        if(category_index != -1){
          this.load_product_key++
          this.category.list[category_index].total_product_display = -1
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/additionalService/index.vue